import {
  initialState,
  Actions,
  State,
  EDIT_WELCOME_CONTENT_POST,
  EDIT_WELCOME_CONTENT_POST_SUCCESS,
  EDIT_WELCOME_CONTENT_POST_ERROR,
  RESET_EDIT_WELCOME_CONTENT_POST,
} from "../../types/welcome-content/edit-welcome-content-post";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case EDIT_WELCOME_CONTENT_POST:
      return {
        ...state,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case EDIT_WELCOME_CONTENT_POST_SUCCESS:
      return {
        ...state,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case EDIT_WELCOME_CONTENT_POST_ERROR:
      return {
        ...state,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_EDIT_WELCOME_CONTENT_POST:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
